import React from 'react';
import { Box, Grid, TextField, Button } from '@mui/material';
import EditorComponent from '../editor/EditorComponent';

const CommentForm = ({ commentValue, onSubmit, handleChange }) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        my: 1,
        px: 2,
      }}
      noValidate
      autoComplete="off"
      onSubmit={onSubmit}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{
          mt: 1,
        }}
      >
        <Grid item xs={12}>
          {/* <TextField
            variant="outlined"
            placeholder="코멘트를 작성해주세요"
            rows={2}
            multiline
            fullWidth
            value={commentValue}
            onChange={handleChange}
          /> */}
          <EditorComponent value={commentValue} onChange={handleChange} />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={1}
      >
        <Button type="submit" color="primary" variant="outlined">
          저장
        </Button>
      </Grid>
    </Box>
  );
};

export default CommentForm;
